import { IDeleteAvaliacaoHabilidadeItemUseCase } from "../../../presentation/useCases/delete/delete_avaliacao_habilidade_item_use_case";
import { AvaliacaoHabilidade } from "../../models/avaliacao_habilidade";
import { HabilidadeItem } from "../../models/habilidade_item";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteAvaliacaoHabilidadeItemUseCase
 */

export class DeleteAvaliacaoHabilidadeItemUseCase implements IDeleteAvaliacaoHabilidadeItemUseCase {
  private _avaliacaoHabilidade!: AvaliacaoHabilidade;
  private _habilidades!: HabilidadeItem[];

  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteAvaliacaoHabilidadeItem(
    idAvaliacaoHabilidadeItem: number,
  ): Promise<void> {
    const { avaliacaoHabilidade, habilidades } = await this.repository.deleteAvaliacaoHabilidadeItem(idAvaliacaoHabilidadeItem);

    this._avaliacaoHabilidade = avaliacaoHabilidade;
    this._habilidades = habilidades;
  }

  get avaliacaoHabilidade(): AvaliacaoHabilidade {
    return this._avaliacaoHabilidade;
  }

  get habilidades(): HabilidadeItem[] {
    return this._habilidades;
  }
}